import * as React from "react";
import { decorateEditorialHtml } from "../../../ContentUtilities";
import { UitkPrimaryButton } from "uitk-react-button";
import { UitkText } from "uitk-react-text";
import { ViewExtraLarge, ViewLarge, Viewport } from "bernie-view";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";

const CONTENT_ID_COUNT = 4;
export const CardComparisonImageSectionEditorial = (props: { items: EditorialModel[] }) => {
  const { items } = props;

  if (items.length !== CONTENT_ID_COUNT) {
    return null;
  }

  const [cardImage, cardImageSubText, cardTitle, cardStatus] = React.useMemo(
    () => items.map((item) => decorateEditorialHtml(item.text)),
    []
  );

  return (
    <div>
      <div dangerouslySetInnerHTML={cardImage} className="all-t-padding-six uitk-type-center" />
      <UitkText align="center" size={200} weight="medium">
        <div dangerouslySetInnerHTML={cardImageSubText} className="all-t-padding-three" />
      </UitkText>
      <UitkText align="center" size={600} weight="bold">
        <div dangerouslySetInnerHTML={cardTitle} className="all-t-padding-four all-b-padding-four" />
      </UitkText>
      <div className="uitk-type-center xl-b-padding-six l-b-padding-six">
        <Viewport>
          <ViewExtraLarge>
            <UitkPrimaryButton type="button" text="Apply Now" />
          </ViewExtraLarge>
          <ViewLarge>
            <UitkPrimaryButton type="button" text="Apply Now" />
          </ViewLarge>
        </Viewport>
      </div>
      <UitkText align="center" size={400} weight="bold">
        <div dangerouslySetInnerHTML={cardStatus} className="all-b-padding-six" />
      </UitkText>
    </div>
  );
};

export default CardComparisonImageSectionEditorial;
